// Mimes from https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Complete_list_of_MIME_types
// matched with a set of storeband allowed extensions
export const MIME_TYPES_TO_EXTENSION = {
  'application/vnd.oasis.opendocument.text': '.odt',
  'application/vnd.oasis.opendocument.spreadsheet': '.ods',
  'application/vnd.oasis.opendocument.presentation': '.odp',
  'application/msword': '.doc',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
    '.docx',
  'application/vnd.ms-excel': '.xls',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': '.xlsx',
  'application/vnd.ms-powerpoint': '.ppt',
  'application/vnd.ms-outlook': '.msg',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation':
    '.pptx',
  'application/pdf': '.pdf',
  'text/plain': '.txt',
  'application/wordperfect': '.wpd',
  'application/rtf': '.rtf',
  'image/jpeg': '.jpg',
  'image/tiff': '.tif',
  'image/bmp': '.bmp',
  'image/png': '.png'
} as const;

export const ACCEPTED_MIME_TYPES = Object.keys(MIME_TYPES_TO_EXTENSION);

function isFileAccepted(file: File, accepts: Array<string>): boolean {
  return !!accepts.find(mimeType => mimeType === file.type);
}

export default isFileAccepted;
